// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__pdNLh","search":"Settings_search__2mHtr","filter":"Settings_filter__1w5ot"};